import { render } from "./AddBonAncien.vue?vue&type=template&id=3a85bd02&scoped=true&ts=true"
import script from "./AddBonAncien.vue?vue&type=script&lang=ts"
export * from "./AddBonAncien.vue?vue&type=script&lang=ts"

import "./AddBonAncien.vue?vue&type=style&index=0&id=3a85bd02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a85bd02"]])

export default __exports__